var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImage2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 37,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18,
  fill: "#fff",
  stroke: "#E1E1E1"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#Image2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.917 12.417H11.083c-.92 0-1.667.746-1.667 1.666v10.833c0 .921.747 1.667 1.667 1.667h15.833c.921 0 1.667-.746 1.667-1.666V14.083c0-.92-.746-1.667-1.666-1.667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2 17.208a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333M9.417 21.442l4.508-5.9M23.583 26.583l-9.658-11.041M18.433 20.267l2.258-2.367M27.459 26.167 20.692 17.9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Image2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 12h20v15H9z"
})))));
export default SvgImage2;